import { render } from "./TemplateList.vue?vue&type=template&id=13be5494&scoped=true&ts=true"
import script from "./TemplateList.vue?vue&type=script&lang=ts"
export * from "./TemplateList.vue?vue&type=script&lang=ts"

import "./TemplateList.vue?vue&type=style&index=0&id=13be5494&scoped=true&lang=css"

import exportComponent from "/builds/weleaf/twd-origination-vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13be5494"]])

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio});
